import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import CustomAlert from '../components/CustomAlert.js';
import RenderField from './RenderField';
import CustomSpinner from './CustomSpinner';


class AuthForm extends Component {

    render() {
        const { handleSubmit, submitting } = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.props.changeSubscriptionEmail)} className='pvc-form'>
                    {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                    {!this.props.error && <CustomAlert bsStyle="warning" message="Este documento está asociado a otro email." description="Por favor ingrese el email que se utilizó para su primer solicitud."/>}
                    {this.props.error && <CustomAlert bsStyle="danger" message={this.props.error}/>}
                    <div className='row'>
                        <div className="col-md-12 col-lg-12">
                            <div className="form-group">
                                <Field className="form-control" name="email" autoComplete="off" component={RenderField} type={'email'} label="Email" showSuccess={true} />
                            </div>
                        </div>
                    </div>
                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Verificar</button>
                </form>
            </div>
        );
    }
}

AuthForm = reduxForm({
    form: 'auth-form',
})(AuthForm);

export default AuthForm;


/** WEBPACK FOOTER **
 ** ./src/components/AuthForm.js
 **/